import { forwardRef, memo } from "react";

import { usePerformance } from "@hooks";

import { Path } from "./Path";

interface BlurredPathProps {
  baseColor: string;
  gradientId: string;
}

const _BlurredPath = forwardRef<SVGPathElement, BlurredPathProps>(
  ({ baseColor, gradientId }: BlurredPathProps, ref) => {
    const { blurSupport } = usePerformance();

    return (
      <>
        {blurSupport && (
          <>
            <Path
              ref={ref}
              stroke={gradientId}
              strokeWidth="8"
              opacity="20%"
              filter="url(#blur)"
            />

            <Path
              stroke={gradientId}
              strokeWidth="8"
              opacity="40%"
              filter="blur(8px)"
            />
          </>
        )}

        <Path stroke={baseColor} strokeWidth="3" />

        <Path stroke={gradientId} strokeWidth="4" />
      </>
    );
  },
);

_BlurredPath.displayName = "BlurredPath";
const BlurredPath = memo(_BlurredPath);
export { BlurredPath };
